import Loader from "../../Loader/Loader";
import "./information-card.scss";

const InformationCard = ({ title, title2, desc, loading, redirectURL, redirectText }:
    { title: string, title2?: string; loading?: boolean; redirectURL?: string | null; redirectText: any; desc: string; }) => {
    return <div className="success-wrapper">
        <div className="success-card">
            <div className="title">
                {title}
                {title2 && <><br /> {title2}</>}
            </div>
            {loading && <div className="spinner-wrapper"><Loader /></div>}
            <div className="desc">
                {desc}
            </div>

            {redirectURL && <a
                className="payment-btn"
                href={redirectURL}
            >
                <span>
                    {redirectText}
                </span>
            </a>}
        </div>
    </div>
}

export default InformationCard;